import { 
  Home, 
  Users, 
  Gamepad2, 
  Crosshair, 
  MessageSquare, 
  HelpCircle, 
  Calendar, 
  Wallet, 
  User, 
  Image, 
  DollarSign, 
  TrendingUp, 
  Clock, 
  ShoppingCart, 
  FileText, 
  Crown, 
  UsersRound 
} from "lucide-react";
import { SidebarLink } from "./types";
import { DropdownItem } from "./SidebarDropdown";

export interface SidebarDropdownConfig {
  label: string;
  icon: string;
  items: DropdownItem[];
}

export const getSidebarLinks = (role: string | null): {
  mainLinks: SidebarLink[];
  roleSpecificLinks: SidebarLink[];
  dropdowns?: SidebarDropdownConfig[];
} => {
  // Define all possible links with role requirements
  const allLinks: SidebarLink[] = [
    // Main links (available to all logged in users)
    { to: "/", label: "Início", icon: "home", roles: ['admin', 'mentor', 'jogador', null], section: 'main' },
    { to: "/mentores", label: "Mentores", icon: "users", roles: ['admin', 'mentor', 'jogador', null], section: 'main' },
    { to: "/jogos", label: "Jogos", icon: "gamepad", roles: ['admin', 'mentor', 'jogador', null], section: 'main' },
    { to: "/mentorias", label: "Mentorias", icon: "crosshair", roles: ['admin', 'mentor', 'jogador', null], section: 'main' },
    { to: "/comunidades", label: "Comunidades", icon: "group", roles: ['admin', 'mentor', 'jogador', null], section: 'main' },
    { to: "/como-funciona", label: "Como Funciona", icon: "help", roles: ['admin', 'jogador', null], section: 'main' },
    
    // Admin-specific links - REMOVIDO DASHBOARD
    { to: "/painel-admin/jogos", label: "Gerenciar Jogos", icon: "gamepad", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/usuarios", label: "Gerenciar Usuários", icon: "users", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/mentorias", label: "Gerenciar Mentorias", icon: "crosshair", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/banners", label: "Gerenciar Banners", icon: "image", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/depoimentos", label: "Gerenciar Depoimentos", icon: "message", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/hero", label: "Configurações do Hero", icon: "image", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/destaques", label: "Gerenciar Destaques", icon: "star", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/saques", label: "Aprovar Saques", icon: "dollar", roles: ['admin'], section: 'app' },
    { to: "/painel-admin/financas", label: "Finanças", icon: "trending", roles: ['admin'], section: 'app' },
    
    // Mentor-specific links - REMOVIDO DASHBOARD
    { to: "/painel-mentor/disponibilidade", label: "Disponibilidade", icon: "calendar", roles: ['mentor'], section: 'app' },
    { to: "/painel-mentor/chat", label: "Chat", icon: "message", roles: ['mentor'], section: 'app' },
    { to: "/painel-mentor/financas", label: "Finanças", icon: "wallet", roles: ['mentor'], section: 'app' },
    { to: "/painel-mentor/perfil", label: "Perfil", icon: "user", roles: ['mentor'], section: 'app' },
    
    // Player-specific links are managed by the PlayerSidebar component
  ];
  
  // Filter links based on user role
  const mainLinks = allLinks.filter(link => 
    link.roles.includes(role as string) && link.section === 'main'
  );
  
  const roleSpecificLinks = allLinks.filter(link => 
    link.roles.includes(role as string) && link.section === 'app'
  );

  // Define dropdowns específicos por role
  let dropdowns: SidebarDropdownConfig[] = [];
  
  if (role === 'mentor') {
    dropdowns = [
      {
        label: "Meus Serviços",
        icon: "users",
        items: [
          {
            to: "/painel-mentor/minhas-mentorias",
            label: "Gerenciar Serviços",
            icon: "users",
            roles: ['mentor'],
            section: 'app'
          },
          {
            to: "/painel-mentor/sessoes-vendidas",
            label: "Mentorias Vendidas",
            icon: "clock",
            roles: ['mentor'],
            section: 'app'
          },
          {
            to: "/painel-mentor/sessoes-compradas",
            label: "Mentorias Compradas",
            icon: "shopping",
            roles: ['mentor'],
            section: 'app'
          },
          {
            to: "/painel-mentor/conteudos-comprados",
            label: "Conteúdos Comprados",
            icon: "file-text",
            roles: ['mentor'],
            section: 'app'
          },
          {
            to: "/painel-mentor/minhas-avaliacoes",
            label: "Minhas Avaliações",
            icon: "message",
            roles: ['mentor'],
            section: 'app'
          }
        ]
      },
      {
        label: "Comunidades",
        icon: "group",
        items: [
          {
            to: "/painel-mentor/comunidades",
            label: "Minhas Comunidades",
            icon: "crown",
            roles: ['mentor'],
            section: 'app'
          },
          {
            to: "/painel-mentor/comunidades-participo",
            label: "Comunidades que Participo",
            icon: "communities",
            roles: ['mentor'],
            section: 'app'
          }
        ]
      }
    ];
  }

  return { mainLinks, roleSpecificLinks, dropdowns };
};
